
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sostenibilita/[slug]",
      function () {
        return require("private-next-pages/sostenibilita/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sostenibilita/[slug]"])
      });
    }
  